import type { WithChildren } from "@neru/types";
import React from "react";

interface CenterProps extends WithChildren {
  className?: string;
  paddingY?: string;
}

const paddingYClasses: Record<string, string> = {
  lg: "py-12",
  md: "py-8",
  sm: "py-4",
  xl: "py-16",
  xs: "py-2",
};

export const Center: React.FC<CenterProps> = ({
  children,
  className = "",
  paddingY = "md",
}) => {
  const paddingClass = paddingYClasses[paddingY] || paddingYClasses["md"];

  return (
    <div
      className={`
        flex h-full flex-1 flex-col items-center justify-center

        ${paddingClass}

        box-border

        ${className}
      `}
    >
      {children}
    </div>
  );
};
